import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, startWith, switchMap } from 'rxjs/internal/operators';
import State from 'src/application/core/State';
import OrderPlaceRequested from '../events/OrderPlaceRequested';
import OrderPlaceSucceed from '../events/OrderPlaceSucceed';
import OrderPlaceFailed from '../events/OrderPlaceFailed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import OrderPlaceRequestSent from '../events/OrderPlaceRequestSent';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(OrderPlaceRequested.type),
        switchMap(() => {
            return backend.post(`${api()}orders/place`, JSON.stringify(state$.value.order.order!)).pipe(
                map((r: AjaxResponse) => new OrderPlaceSucceed(r.response.articlesOrdersDrafts, r.response.itemValidationResult)),
                catchError((e: AjaxError) => of(new OrderPlaceFailed(e.response))),
                startWith(new OrderPlaceRequestSent())
            );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/order/epic/orderPlace.ts